function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgCheckboxEd(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M70.827 7H26.173C16.152 7 8 15.152 8 25.173v45.154C8 80.348 16.152 88.5 26.173 88.5h44.654C80.848 88.5 89 80.348 89 70.327V25.173C89 15.152 80.848 7 70.827 7zm1.78 34.225L48.651 65.182c-.054.054-.117.091-.172.141a4.04 4.04 0 01-.725.514c-.094.052-.186.105-.283.149a3.963 3.963 0 01-.557.197c-.083.023-.162.055-.246.073a4.027 4.027 0 01-.839.096h-.003c-.234 0-.469-.026-.701-.068-.071-.013-.141-.034-.211-.051a3.997 3.997 0 01-.473-.14c-.083-.031-.164-.067-.246-.103a3.978 3.978 0 01-.408-.215c-.08-.048-.16-.095-.238-.15-.037-.026-.078-.044-.114-.072L27.461 53.574a3.993 3.993 0 014.791-6.389l13.201 9.901 21.508-21.508a3.994 3.994 0 015.646 5.647z"
  }));
}

SvgCheckboxEd.clsName = 'icon-www__checkbox-ed';
SvgCheckboxEd.remarkName = 'unknown';
export default SvgCheckboxEd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/CheckboxEd.js
// module id = 2303
// module chunks = 17 18